import {Skeleton} from '@/components/sections/products/skeleton/ProductSkeleton';

export default function ProductSkeletonGrid() {
	return (
			<div className="skeleton-wrapper row">
				<Skeleton className="rounded mb-3 col-12 h-big"/>
				<div className="col-12">
					<Skeleton className="h-3 w-100"/>
					<Skeleton className="mt-3 h-3 w-100"/>
					<Skeleton className="mt-3 h-3 w-100"/>
				</div>
			</div>
	);
}
